import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import { Button, Row, Col } from 'reactstrap'
import { useTranslation } from 'react-i18next'

import useFetchStatus from 'customHooks/useFetchStatus'
import ReactTable from 'main_views/components/ReactTable'
import Alert from "main_views/components/alert"
import Modal from "main_views/components/Modal"
import Form from 'main_views/components/Form/form_v2'
import { deleteDoc } from 'dbHandler'
import { successToast, errorToast } from 'main_views/components/toast'
import GeneralInfoForm from './generalInfoForm'
import GatewayForm from './gatewayForm'
import priorityAndDateFields from './priorityAndDateFields'

function FormsList() {

   let { t } = useTranslation()

   let [updateForms, setUpdateForms] = useState(0)
   let [forms, formsError, formsIsLoading] = useFetchStatus(`forms`, {}, [updateForms])
   let [formsData, setFormsData] = useState([])
   let [selectedForm, setSelectedForm] = useState()
   let [filteredData, setFilteredData] = useState()

   // modals
   let [showGatwayModal, setShowGatwayModal] = useState(false)
   let [showPreviewModal, setShowPreviewModal] = useState(false)
   let [showInfoModal, setInfoModal] = useState(false)

   // alert
   let [alert, setAlert] = useState(null)

   // loading
   let [isDeleting, setIsDeleting] = useState(false)

   useEffect(() => setFormsData(_.values(forms)), [forms])

   let header = [
      {
         Header: t('name'),
         accessor: 'name',
         sortable: true,
         type: 'string'
      },
      {
         Header: t('created_by'),
         accessor: 'createdByStaffName',
         sortable: true,
         type: 'string'
      },
      {
         Header: " ",
         type: "buttons",
         sortable: false,
         btns: [
            {
               buttonTitle: t('getway'),
               color: 'primary',
               isOutline: true,
               onClick: (idx) => {
                  setSelectedForm(filteredData[idx])
                  setShowGatwayModal(true)
               },
            },
            {
               buttonTitle: t('preivew'),
               color: 'primary',
               isOutline: true,
               onClick: (idx) => {
                  setSelectedForm(filteredData[idx])
                  setShowPreviewModal(true)
               },
            },
         ],
      },
      {
         Header: '',
         sortable: false,
         type: 'editAndDeleteButtons',
         onEdit: (idx) => {
            setSelectedForm(filteredData[idx])
            setInfoModal(true)
         },
         onDelete: (idx) => deleteConfirmAlert(idx),
      },
   ]

   let deleteConfirmAlert = (index) =>
      setAlert({
         show: true,
         isError: true,
         title: `Are you sure you want to delete the ${_.get(filteredData[index], 'name', '')} form?`,
         // msg: ``,
         confirmBtnText: "Yes, delete it!",
         cancelBtnText: "Cancel",
         showCancelBtn: true,
         handelCancel: () => setAlert(null),
         handelConfirm: () => {
            setAlert(null)
            deleteForm(index)
         },
      })

   let deleteForm = async (index) => {


      let formId = _.get(filteredData, `[${index}].id`)

      setIsDeleting(true)

      try {

         /**
          * NOTE: 
          *    if the form has an open ticket >> just delete the form and leave the getaway
          *    otherwise, delete both (form, getway)
          */

         // check if there is an active ticket
         let db = window.firebaseFirestore
         let ref = db.collection(`tickets`).where('formId', '==', formId).where('inProgress', '==', true)

         let openTickets = await ref.limit(1).get()

         let hasOpenTicket = !openTickets.empty

         // find the gateway of the form
         let formGatewayRef = db.collection(`gateway`).where('formId', '==', formId)
         formGatewayRef = await formGatewayRef.limit(1).get()

         let gatewayId
         formGatewayRef.forEach((doc) => gatewayId = doc.id) // its 1-to-1 relation, so it's only one doc

         if (hasOpenTicket) {
            // just delete the form
            await deleteDoc(`forms/${formId}`)

         } else {
            // delete the form & gateway
            await Promise.all([
               deleteDoc(`forms/${formId}`),
               deleteDoc(`gateway/${gatewayId}`)
            ])
            
         }

         updateFormList()
         successToast(t('form_was_deleted'))


      } catch (error) {
         console.log("deleteForm -> error", error)

         errorToast(t('something_wrong'))

      } finally {

         setIsDeleting(false)

      }

   }

   let updateFormList = () => setUpdateForms(++updateForms)

   return (
      <div className="content">

         <ReactTable
            title={t('forms_list')}
            header={header}
            body={formsData}
            hasSearchBar={true}
            loading={formsIsLoading || isDeleting}
            setFilterResult={setFilteredData}
         />


         {/* General info Modal (form name, created by, remider days, is allow file attch) */}
         <Modal
            isOpen={showInfoModal}
            toggle={() => setInfoModal(!showInfoModal)}
            title={t('form_general_info')}
            subTitle={`${_.get(selectedForm, 'name')}`}
         >

            <GeneralInfoForm
               selectedFormFields={selectedForm}
               toggle={setInfoModal}
               updateFormList={updateFormList} />

         </Modal>

         {/* Preview Modal */}
         <Modal
            isOpen={showPreviewModal}
            toggle={() => setShowPreviewModal(!showPreviewModal)}
            title={t('form_preview')}
            subTitle={`${_.get(selectedForm, 'name')}`}
         >
            <Form
               inputs={_.concat(_.get(selectedForm, 'data', []), priorityAndDateFields)}
               onChange={() => { }}
               // readOnly={true}
            />

         </Modal>

         {/* Gatway Modal */}
         <Modal
            isOpen={showGatwayModal}
            toggle={() => setShowGatwayModal(!showGatwayModal)}
            title={t('form_gatway')}
            subTitle={`${_.get(selectedForm, 'name')}`}
         >

            <GatewayForm
               selectedFormFields={selectedForm}
               toggle={setShowGatwayModal}
               updateFormList={updateFormList}
            />

         </Modal>

         <Alert {...alert} />

      </div>
   )
}

export default FormsList


